import {
    PACKAGES_DELETE_PACKAGE_OPEN_MODAL,
    PACKAGES_DELETE_PACKAGE_REQUEST,
    PACKAGES_DELETE_PACKAGE_RESULT,
} from 'Redux/actionTypes';

export const packagesDeletePackageOpenModal = (id) => ({
    type: PACKAGES_DELETE_PACKAGE_OPEN_MODAL,
    payload: id
})

export const packagesDeletePackageRequest = (data) => ({
    type: PACKAGES_DELETE_PACKAGE_REQUEST,
    payload: data
})

export const packagesDeletePackageResult = (result) => ({
    type: PACKAGES_DELETE_PACKAGE_RESULT,
    payload: result
})